import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import { fetchUserSubscriptions } from "../../services/userSubscriptionService";

const MyPlansPage = () => {
  const [userPlans, setUserPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  /* ===============================
     FETCH ALL USER PLANS (JWT-based)
  =============================== */
  useEffect(() => {
    fetchUserPlans();
  }, []);


  const getPlanTypeLabel = (type) => {
  switch (type) {
    case "ONE_ON_ONE":
      return "One-On-One";
    case "GROUP":
      return "Group Practice";
    case "GROUP_DISCUSSION":
      return "Group Discussion";
    default:
      return "N/A"; // fallback when null
  }
};

  const fetchUserPlans = async () => {
    try {
      const plans = await fetchUserSubscriptions();
      setUserPlans(plans);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/login");
      } else {

      }
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     NAVIGATE TO PLANS PAGE
  =============================== */
  const handlePurchaseNewPlan = () => {
    navigate("/plans");
  };

  /* ===============================
     UI
  =============================== */
  return (
    <div>
      <Navbar />

      <div style={styles.container}>
        <h2 style={styles.heading}>My Plans</h2>

        {loading ? (
          <p>Loading your plans...</p>
        ) : userPlans.length === 0 ? (
          <p>No purchased plans yet.</p>
        ) : (
          <div style={styles.grid}>
            {userPlans.map((subscription) => {
              const isActive = subscription.status === "ACTIVE";
              const progress =
                subscription.totalSessions > 0
                  ? (subscription.remainingSessions /
                      subscription.totalSessions) *
                    100
                  : 0;

              return (
                <div
                  key={subscription.id || subscription.planName}
                  style={{
                    ...styles.card,
                    borderColor: isActive ? "#007BFF" : "#ccc",
                    backgroundColor: isActive
                      ? "#f0f8ff"
                      : "#f9f9f9",
                    transform: isActive
                      ? "scale(1.02)"
                      : "scale(1)",
                  }}
                >
                  {isActive && (
                    <div style={styles.activeBadge}>
                      Active Plan
                    </div>
                  )}

                  <h3>{subscription.planName}</h3>

                  <p style={{ color: "#555" }}>
                    {subscription.planDescription || ""}
                  </p>

                  <p>
  <strong>Plan Type:</strong>{" "}
  {getPlanTypeLabel(subscription.planType)}
</p>

                  <p>
                    <strong>Session Duration:</strong>{" "}
                    {subscription.planDurationMinutes} mins
                  </p>

                  {subscription.validityDays && (
                    <p>
                      <strong>Validity:</strong>{" "}
                      {subscription.validityDays} days
                    </p>
                  )}

                  <hr style={{ margin: "10px 0" }} />

                  <p>
                    <strong>Status:</strong>{" "}
                    {subscription.status}
                  </p>

                  <p>
                    <strong>Total Sessions:</strong>{" "}
                    {subscription.totalSessions}
                  </p>

                  <p>
                    <strong>Remaining Sessions:</strong>{" "}
                    {subscription.remainingSessions}
                  </p>

                  {isActive &&
                    subscription.totalSessions > 0 && (
                      <div style={styles.progressBarContainer}>
                        <div
                          style={{
                            ...styles.progressBar,
                            width: `${progress}%`,
                          }}
                        />
                      </div>
                    )}

                  {/* <p>
                    <strong>Start Date:</strong>{" "}
                    {subscription.startDate}
                  </p>*/}

                  {subscription.endDate && (
                    <p>
                      <strong>End Date:</strong>{" "}
                      {subscription.endDate}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* ===============================
           PURCHASE NEW PLAN BUTTON
        =============================== */}
        <div style={styles.buttonContainer}>
          <button
            style={styles.purchaseButton}
            onClick={handlePurchaseNewPlan}
          >
            Purchase New Plan
          </button>
        </div>
      </div>
    </div>
  );
};

/* ===============================
   STYLES
=============================== */
const styles = {
  container: {
    padding: "40px",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "2rem",
    color: "#007BFF",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "center",
    marginBottom: "40px",
  },
  card: {
    position: "relative",
    width: "300px",
    padding: "25px",
    borderRadius: "12px",
    border: "2px solid #ccc",
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    backgroundColor: "#f9f9f9",
    textAlign: "center",
    transition: "all 0.3s ease",
  },
  activeBadge: {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    backgroundColor: "#007BFF",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "12px",
    fontSize: "0.8rem",
    fontWeight: "bold",
  },
  progressBarContainer: {
    height: "10px",
    width: "100%",
    backgroundColor: "#ddd",
    borderRadius: "5px",
    margin: "10px 0",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#28a745",
    borderRadius: "5px",
    transition: "width 0.3s ease",
  },
  buttonContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  purchaseButton: {
    padding: "12px 25px",
    borderRadius: "8px",
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    fontSize: "1rem",
    fontWeight: "500",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    transition: "all 0.2s ease",
  },
};

export default MyPlansPage;
